import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import PropTypes from "prop-types";
import PropertyCard from "./PropertyCard";
import { getTimeAgo } from "../../utils/helper/getTimeAgo";

const GridWrap = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 24px;
  padding: 0;
`;

const PropertyGrid = ({ properties }) => {
  const navigate = useNavigate();

  return (
    <GridWrap>
      {properties.map((property, index) => {
        const openDetail = () =>
          navigate(`/rentals/property/${property.landlordId}/${property.id}`);

        return (
          <PropertyCard
            key={index}
            image={property.photos?.[0]}
            badges={property.badges}
            title={property.title}
            address={property.address}
            features={property.utilities}
            beds={property.bedrooms}
            bathrooms={property.bathrooms}
            price={property.rent}
            tags={property.tags}
            listedAgo={getTimeAgo(property.createdAt)}
            onTourClick={openDetail}
            onAvailabilityClick={openDetail}
            onOpen={openDetail}
          />
        );
      })}
    </GridWrap>
  );
};

PropertyGrid.propTypes = {
  properties: PropTypes.arrayOf(
    PropTypes.shape({
      landlordId: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      badges: PropTypes.array,
      title: PropTypes.string.isRequired,
      address: PropTypes.string.isRequired,
      features: PropTypes.string,
      price: PropTypes.string,
      tags: PropTypes.arrayOf(PropTypes.string),
    })
  ).isRequired,
};

export default PropertyGrid;
